import styled from 'styled-components'
import {
  flexDirection,
  FlexDirectionProps,
  padding,
  PaddingProps,
} from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { LANDING_CONTENT_WIDTH_PX } from 'Constants/Landing'

import { gap, GapProps } from 'Services/Styles'

const shouldForwardProp = (prop: string) =>
  !DIV_SHOULD_FORWARD_PROP.includes(prop)

export const Container = styled.div.withConfig({ shouldForwardProp })<
  PaddingProps & GapProps
>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: ${themeGet('colors.background.screenAlt')};
  overflow: hidden;

  ${padding}
  ${gap}
`

export const Content = styled.div.withConfig({
  shouldForwardProp,
})<FlexDirectionProps & PaddingProps & GapProps>`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: ${LANDING_CONTENT_WIDTH_PX}px;

  ${flexDirection}
  ${padding}
  ${gap}
`
